
export class MottagningsplatsListRequestDTO   {

    id: number;
    namn: string;
    aktiv: boolean;
    mottagningsplatsnummer: string;
    mottagningsplatstyp: string;
    beskrivning: string;
    egenTerminal?: boolean;
    ansvarigLogistiker: string;

    constructor() {
        this.id = undefined;
        this.namn = undefined;
        this.aktiv = undefined;
        this.mottagningsplatsnummer = undefined;
        this.mottagningsplatstyp = undefined;
        this.beskrivning = undefined;
        this.egenTerminal = undefined;
        this.ansvarigLogistiker = undefined;
    }
}
